import { render, staticRenderFns } from "./banking.vue?vue&type=template&id=1d81beb8&scoped=true&"
import script from "./banking.vue?vue&type=script&lang=js&"
export * from "./banking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d81beb8",
  null
  
)

export default component.exports